import React from 'react';

type justifyContentsTypes = "start" | "end" | "center" | "between" | "around"
type alignItemsTypes = "start" | "end" | "center"
type direction = "row" | "col"
interface FlexInterface extends React.HTMLAttributes<HTMLDivElement>  {
    inline?: boolean
    block?: boolean
    full?: boolean
    justifyContents?: justifyContentsTypes
    alignItems?: alignItemsTypes
    direction?: direction
    gap?: number
    wrap?: boolean
    rect?: number[]
}
const Flex = React.forwardRef<HTMLDivElement, FlexInterface>(
    (props, ref) => {
        const { inline,
            block,
            full,
            justifyContents,
            alignItems,
            direction,
            gap,
            wrap,
            rect, ...rest } = props;
        const divStyle = { ...props.style };

        rest.className = rest.className ?? "";
        rest.className += " --flex"
        if(inline){
            rest.className += " --inflex"
        }
        rest.className += "-" + justifyContents + "-" + alignItems
        rest.className += " " + "--flex-direction-"+direction
        if(wrap){
            rest.className += " " + "--flex-wrap"
        }

        if (typeof gap === "number") {
            divStyle["gridGap"] = gap * 0.1 + "rem";
        }
        if(block){
            divStyle["width"] = "100%";
        }
        if(full){
            divStyle["height"] = "100%";
        }

        if (Array.isArray(rect) && rect.length === 2 && typeof rect[0] === "number" && typeof rect[1] === "number") {
            divStyle["width"] = rect[0] * 0.1 + "rem";
            divStyle["height"] = rect[1] * 0.1 + "rem";
        }

        return <div {...rest} style={divStyle} ref={ref} ></div>;
    }
);

Flex.defaultProps = {
    inline: false,
    block: false,
    justifyContents: "start",
    alignItems: "start",
    direction: "row",
    wrap: false,
    gap: 0,
    className: ""
}

export default Flex;